import React from 'react'
import { Paper, styled } from '@mui/material'

export const Root = styled(({ position, ...props }) => <Paper {...props} />)`
  background-color: transparent;
  border-bottom: ${props => (props.tabsCount > 0 ? `1px solid ${props.theme.palette.custom.gray[75.5]}` : '')};
  border-radius: 0;
  position: ${props => props.position};
`
